import { SET_DASHBOARD_LOADING, SET_DASHBOARD_LOGS, SET_DASHBOARD_SERVERS } from "./types";
import { api } from "../App";



export const getLogsData = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/logs');
    dispatch({ type: SET_DASHBOARD_LOGS, payload: data.logs });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: false });
  }
}

export const getServersData = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/servers');
    dispatch({ type: SET_DASHBOARD_SERVERS, payload: data.servers });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: false });
  }
}